import _ from 'lodash';
import React, { Component } from 'react';
import CategorySelect from './CategorySelect';
import moneyFormat from '../../utilities/moneyFormat';
import { JqueryClassFaker } from './JqueryClassFaker';
import Button from './Button';
import Transaction from '../../models/Transaction';
import TransactionMoneyComponent from '../elements/TransactionMoneyComponent';
import moment from 'moment';
import CurrencyInput from '../elements/CurrencyInput';
import TextInput from '../elements/TextInput';
import getCategoryById from '../../utilities/getCategoryById';
import Modal from './Modal';
import store from 'redux/store/store.js';
import { setTransactionToEditMode } from 'redux/actions/dashboard';
import InputSwitch from './InputSwitch.jsx';
import TransactionBankInformation from './TransactionBankInformation.jsx';
import InstitutionLogo from './InstitutionLogo.jsx';
import MaterialIcon from '../elements/MaterialIcon.jsx';
import CircleLoader from './CircleLoader.jsx';
import TransactionSummarySplit from './transaction/TransactionSummarySplit.jsx';
import TransactionEditPanel from './transaction/TransactionEditPanel.jsx';
import PendingText from 'react/components/PendingText';
import InlineCircleLoader from 'react/components/InlineCircleLoader';
import { removeOfflineTransactionAttempt } from 'redux/actions/transactions';

export default class TransactionSummaryComponent extends Component {
	static defaultProps = {
		viewOnly: false,
		showCategory: true,
		showSplitCategories: true,
		categoryEditable: true,
		editOnly: false,
		showExternalTransactionControls: true,
		showInstitution: true,
		isEditModal: false,
		transactionBeingEditedModalShouldBeOpen: true,
		allowDeletingOfflineTransaction: false,
	};

	constructor(props) {
		super(props);

		const { transactionDelete, transactionDeleteUndo, transaction, editOnly } = this.props;
		this.state = {
			editing: !!editOnly,
			dateEditDay: this.getDayEditDayToDisplay(),
		};

		this.beginTransactionEdit = this.beginTransactionEdit.bind(this);
		this.endTransactionEdit = this.endTransactionEdit.bind(this);
		this.categorySet = this.categorySet.bind(this);
		this.highlightTransaction = this.highlightTransaction.bind(this);

		this.addBankTransactionAsTransaction = this.addBankTransactionAsTransaction.bind(this);

		this.editSplitChange = this.editSplitChange.bind(this);
		this.editSplitAmount = this.editSplitAmount.bind(this);

		this.editTransactionChange = this.editTransactionChange.bind(this);
		this.editAmountChange = this.editAmountChange.bind(this);

		this.firstInputRef = React.createRef();
		this.transactionSubmitter = this.transactionSubmitter.bind(this);
		this.transactionDelete = transactionDelete ? this.transactionDelete.bind(this) : undefined;
		this.transactionDeleteUndo = transactionDeleteUndo ? transactionDeleteUndo.bind(null, transaction) : undefined;
		this.editTransactionBlur = this.editTransactionBlur.bind(this);

		this.onEnterPress = this.onEnterPress.bind(this);

		this.hideBankTransaction = this.hideBankTransaction.bind(this);
		this.unhideBankTransaction = this.unhideBankTransaction.bind(this);
		this.toggleAmountSign = this.toggleAmountSign.bind(this);
	}

	componentDidMount() {
		const { transaction } = this.props;

		if(!_.isString(transaction)) {
			this.isBankTransaction = transaction.isBankTransaction();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { transaction } = this.props;
		if(_.isString(prevProps.transaction) && !_.isString(transaction)) {
			this.isBankTransaction = transaction.isBankTransaction();
		}
		if(this.isBankTransaction && !transaction.isBankTransaction()) {
			this.isBankTransaction = false;
			// this.highlightTransaction();
			this.setState({
				dateEditDay: this.getDayEditDayToDisplay()
			});
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let shouldUpdate = [];
		_.each({ ...nextProps }, (nextProp, key) => {
			if(nextProp !== this.props[key]) {
				switch(key) {
					case 'highlightedTransaction': {
						if(nextProps.highlightedTransaction === this.props.transaction.id) {
							shouldUpdate.push(`${key}-1`);
						}
						if(this.props.highlightedTransaction === this.props.transaction.id &&
							nextProps.highlightedTransaction !== this.props.transaction.id) {
							shouldUpdate.push(`${key}-2`);
						}
						break;
					}
					default: {
						shouldUpdate.push(key);
					}
				}
			}
		});
		_.each({ ...nextState }, (nextStateValue, key) => {
			if(nextStateValue !== this.state[key]) {
				switch(key) {
					default: {
						shouldUpdate.push(key);
					}
				}
			}
		});
		return shouldUpdate.length > 0;
	}

	getDayEditDayToDisplay() {
		const { transaction } = this.props;
		return transaction.transaction_date ? transaction.transaction_date.date() : '';
	}

	toggleAmountSign() {
		const { transaction } = this.props;
		transaction.toggleAmountSign();
		this.forceUpdate();
	}

	addBankTransactionAsTransaction() {
		const { transaction, addBankTransactionAsTransaction } = this.props;
		addBankTransactionAsTransaction(transaction);
	}

	hideBankTransaction() {
		const { transaction, hideBankTransaction } = this.props;
		hideBankTransaction(transaction);
	}

	unhideBankTransaction() {
		const { transaction, unhideBankTransaction } = this.props;
		unhideBankTransaction(transaction);
	}

	// The edit panel asks before calling this.
	transactionDelete() {
		const { transaction, transactionDelete } = this.props;
		transactionDelete(transaction);
	}

	editSplitChange(transactionSplit, event) {
		console.log('the event', event);
		const { name, value } = event;
		const { editing } = this.state;
		const { transaction } = this.props;

		transactionSplit[name] = value;
		console.log('edit split change?!', name, value);
		if(name === 'category_id' && (transaction.submit_id || transactionSplit.id) && !editing) {
			this.transactionSubmitter();
		}
		this.forceUpdate();
	}

	editSplitAmount(transactionSplit, total) {
		transactionSplit.update({ amount: total });
		this.forceUpdate();
	}

	highlightTransaction(event) {
		const { transaction, isEditModal } = this.props;
		if(isEditModal) {
			return;
		}
		if(transaction.isBankTransaction()) {
			console.log('is bank transaction');
			return;
		}
		store.dispatch(setTransactionToEditMode(transaction.clone()));

		// this.beginTransactionEdit();
	}

	beginTransactionEdit() {
		const { viewOnly } = this.props;
		const { editing } = this.state;
		if(viewOnly || editing) {
			return;
		}
		alert('Removesies');
		// this.setState({
		// 	editing: true
		// });
	}

	endTransactionEdit() {
		const { transaction, editOnly, endTransactionEdit, cancelledAddAsBankTransaction } = this.props;
		if(!transaction.isBankTransaction()) {
			transaction.clearEmptySplits();
		}

		if(!editOnly) {
			this.setState({
				editing: false
			});
			if(!transaction.id && transaction.plaid_transaction_id && !transaction.submitting) {
				this.isBankTransaction = true;
				cancelledAddAsBankTransaction(transaction);
			}
		}
		if(endTransactionEdit) {
			endTransactionEdit();
		}
	}

	categorySet(categories) {
		const { transactionSubmit, transactionCategoryEdit, isEditModal } = this.props;
		let { transaction } = this.props;
		let shouldSubmitChanges = false;
		if(transaction.isBankTransaction()) {
			transaction = transaction.createTransaction();
			shouldSubmitChanges = true;
		}
		const isExpenseCategoryBeforeChange = transaction.isSetToAnExpenseCategory();
		let oneOrLessCategoriesAreSelected = true;
		if(Array.isArray(categories)) {
			const allSplits = [];
			const splitsToAdd = [];
			let categoryIdMap = {};
			const allSplitsById = {};
			for(let split of transaction.splits) {
				allSplits.push(split);
				allSplitsById[split.category_id] = split.category_id;
			}
			for(let category of categories) {
				categoryIdMap[category.value] = category.value;
				if(!allSplitsById[category.value]) {
					splitsToAdd.push(category.value);
				}
			}
			let splitsToRemove = allSplits.filter((split) => {
				return !categoryIdMap[split.category_id];
			});
			for(let splitToRemove of splitsToRemove) {
				transaction.removeSplit(splitToRemove);
			}

			if(transaction.splits.length === 1) { //At this point we need no splits
				transaction.removeSplit(transaction.splits[0]);
			}

			const getBlankSplit = () => {
				let blankSplit = null;
				for(let split of transaction.splits) {
					if(split.isUnset()) {
						blankSplit = split;
						break;
					}
				}
				if(!blankSplit) {
					if(splitsToAdd.length + transaction.splits.length === 1) {
						return null;
					} else {
						transaction.addSplit();
						return getBlankSplit();
					}
				}
				return blankSplit;
			};
			for(let splitToAdd of splitsToAdd) {
				const blankSplit = getBlankSplit();
				if(blankSplit) {
					blankSplit.category_id = splitToAdd;
				}
			}
			switch(categories.length) {
				case 0:
					categories = { value: '0' }; // NO Categories
					break;
				case 1:
					categories = categories[0]; // One category Selected
					break;
				default: {
					// Multiple categories selected, so we only update the splits
					oneOrLessCategoriesAreSelected = false;
					console.log('we has the splits?', transaction.splits);
				}
			}
		}
		if(oneOrLessCategoriesAreSelected) {
			transactionCategoryEdit(transaction, categories ? categories.value : null, !isEditModal);
		}
		if(transaction.isSetToAnExpenseCategory() !== isExpenseCategoryBeforeChange) {
			transaction.toggleAmountSign();
		}
		if(shouldSubmitChanges) {
			transactionSubmit(transaction);
		}
		this.forceUpdate();
	}

	onEnterPress(event) {
		if(event.key === 'Enter' && event.shiftKey === false) {
			event.preventDefault();
			this.transactionSubmitter();
		}
	}

	transactionSubmitter() {
		const { transactionSubmit, transaction, endTransactionEdit } = this.props;

		transactionSubmit(transaction, this.firstInputRef.current)
			.then(() => {
				if(this.firstInputRef.current) {
					this.firstInputRef.current.focus();
				}
			});
		if(transaction.id) {
			if(endTransactionEdit) {
				endTransactionEdit();
			} else {
				this.endTransactionEdit();
			}
		}
	}

	onSubmit(event) {
		event.preventDefault();
	}

	editAmountChange(total) {
		const { transaction } = this.props;
		transaction.amount = total;
		console.log('amount updated', transaction, transaction.amount);
		this.forceUpdate();
	}

	editTransactionBlur(event) {
		const { transaction, selectedDate } = this.props;
		const { dateEditDay } = this.state;
		const { name, value } = event.target;
		switch(name) {
			case 'dateEditDay':
			case 'transaction_date': {
				console.log('blurred', value, dateEditDay);
				let startPoint = null;


				if(transaction.id) {
					startPoint = transaction.transaction_date;
				} else {
					startPoint = selectedDate;
				}
				startPoint = startPoint.clone();

				if(transaction.id) {
					startPoint = moment(value);
				} else {
					if(value > startPoint.daysInMonth()) {
						startPoint.date(startPoint.daysInMonth());
					} else if(value < 1) {
						startPoint.date(1);
					} else {
						startPoint.date(dateEditDay);
					}
				}

				if(startPoint.isValid()) {
					transaction.transaction_date = startPoint;
					this.setState({
						dateEditDay: startPoint.date()
					});
				} else {
					console.error('date was not valid!');
				}
				break;
			}
			default: {
				transaction[name] = value;
			}
		}
		this.forceUpdate();
	}

	editTransactionChange(event) {
		const { transaction, selectedDate } = this.props;
		if(event === null) {
			return;
		}
		const { name, value } = event.target;
		switch(name) {
			case 'dateEditDay': {
				this.setState({
					dateEditDay: value
				});
				break;
			}
			case 'transaction_date': {
				let startPoint = null;
				if(transaction.id) {
					startPoint = transaction.transaction_date;
				} else {
					startPoint = selectedDate;
				}
				startPoint = startPoint.clone();

				if(transaction.id) {
					startPoint = moment(value);
				}
				if(startPoint.isValid()) {
					transaction.transaction_date = startPoint;
				} else {
					console.error('date was not valid!');
				}
				break;
			}
			default: {
				transaction[name] = value;
			}
		}
		this.forceUpdate();
	}

	renderMainSummaryRow({
		                     categories,
		                     showCategory,
		                     showInstitution,
		                     isBankTransaction,
		                     editing,
		                     transaction,
		                     description,
		                     categoryToDisplay,
		                     addingForSpecificCategory,
		                     isSaving,
		                     where,
		                     pending,
		                     transaction_date,
		                     amountDisplayed,
		                     dateEditDay,
		                     lastEditedTransactionId,
		                     onClick,
		                     isPendingServerUpdate,
	                     }) {
		const {
			allowDeletingOfflineTransaction,
			categoryEditable,
			showExternalTransactionControls,
			transactionFinder,
			refundMatch,
		} = this.props;
		const hasUpdatePending = transactionFinder && transactionFinder.hasUpdatePending(transaction);

		const showsCategoryHugger = !editing && transaction?.getPlaidTransaction()?.account?.institution;
		const categorySegment = showCategory && (
			<span
				className={`category col ${editing ? 's12 ' : 's4 '} ${showsCategoryHugger ? 'has_bank_information' : null}`}
			>
				<React.Fragment>
					{
						<React.Fragment>
							{(!transaction.isSplit() || editing) &&
							<React.Fragment>
								<CategorySelect
									isMulti={editing}
									viewOnly={!categoryEditable}
									value={transaction.isSplit()
										? transaction.splits.map((split) => (split.category_id)) :
										categoryToDisplay}
									onChange={this.categorySet}
									disabled={addingForSpecificCategory || transaction.isSplit()}
									categories={categories}
									blank={Transaction.getBlankTransactionCategoryDisplayText(transaction)}
									transactionName={transaction.where}
								/>
								{/** isBankTransaction && showExternalTransactionControls &&*/}
								{showsCategoryHugger &&
								<div className='bank_transaction_options text_hugger'>
									<TransactionBankInformation
										transaction={transaction}
									/>
								</div>
								}
							</React.Fragment>
							}
							{transaction.isSplit() && !editing &&
							<div>
								--- Split ---
							</div>
							}
						</React.Fragment>
					}
				</React.Fragment>
			</span>
		);

		if(editing) {
			return (
				<React.Fragment>
					<span
						className={`name col s12
						${showCategory ? '' : 's9'}
						${where === '' ? 'error' : ''}`}>
						<div className='input-field'>
							<TextInput
								textarea
								ref={this.firstInputRef}
								onKeyDown={this.onEnterPress}
								onChange={this.editTransactionChange}
								onBlur={this.editTransactionBlur}
								disabled={!!isSaving}
								name='where'
								label='Where'
								value={transaction.where !== null ? transaction.where : ''}
							/>
						</div>
						<div className='input-field'>
							<TextInput
								textarea
								onKeyDown={this.onEnterPress}
								onChange={this.editTransactionChange}
								onBlur={this.editTransactionBlur}
								name='description'
								label='Description'
								value={transaction.description === null ? '' : transaction.description}
								disabled={!!isSaving}
							/>
						</div>
						<TransactionBankInformation
							transaction={transaction}
							showPending
						/>
					</span>

					{categorySegment}
					<div className='total_and_when'>
						{!transaction.id &&
						<span className='date vertical-fields input-field'>
							<React.Fragment>
								<div className='month emphasized'>
									{transaction.transaction_date.format('MMM')}
								</div>
								<div className='input-field'>
									<TextInput
										disabled={!!isSaving}
										onChange={this.editTransactionChange}
										type='number'
										onBlur={this.editTransactionBlur}
										name='dateEditDay'
										value={dateEditDay}
										className='day_field'
									/>
								</div>
								<div className='year emphasized'>
									{transaction.transaction_date.format('YYYY')}
								</div>
							</React.Fragment>
						</span>
						}
						{!!transaction.id &&
						<span className='date vertical-fields input-field '>
							<div className='emphasized'>
								When
							</div>
							<div className='input-field'>
							<input
								onChange={this.editTransactionChange}
								name='transaction_date'
								type='date'
								value={transaction.transaction_date ? transaction.transaction_date.format('YYYY-MM-DD') : ''} />
							</div>
						</span>
						}
						<span
							className={`amount input-field vertical-fields`}>
							<div className='emphasized'>
								Total
							</div>
							<div className='input-field'>
								<CurrencyInput
									className='amount_field'
									allowNegative={true}
									onKeyDown={this.onEnterPress}
									onChange={this.editAmountChange}
									disabled={!!isSaving}
									name='amount'
									value={transaction.amount}
								/>
							</div>
							<div
								className='linked_buttons'
							>
								<InputSwitch
									highlightsSelections
									onContent={<span className='expense_label'>Expense</span>}
									offContent={<span className='income_label'>Income</span>}
									onChange={this.toggleAmountSign}
									checked={transaction.isAnExpenseBasedOnAmountAndCategory()}
								/>
							</div>
						</span>
					</div>

				</React.Fragment>
			);
		} else {
			const whereText = where === '' ? '(No Description!)' : where;
			const descriptionText = (description === '' || description === null || description === undefined) ? '' : ` (${description})`;
			return (
				<React.Fragment>
					{categorySegment}
					<span
						onClick={onClick}
						className={`name col s5
						${onClick ? 'clickable' : ''}
					${showCategory ? '' : 's9'}
					${where === '' ? 'error' : ''}`}>
						<div className='name_summary'>
							{isBankTransaction && showInstitution &&
							<div className='institution'>
								{transaction?.account.getDisplayName()}
							</div>
							}
							<span className='where' title={whereText}>
								{false && transaction?.getPlaidTransaction()?.account?.institution &&
								<span
									className='logo'
								>
									<InstitutionLogo
										institution={transaction?.getPlaidTransaction()?.account?.institution}
									/>
								</span>
								}
								{whereText}
								{descriptionText}
								{hasUpdatePending && <React.Fragment />}
							</span>
							{refundMatch &&
							<span className='hint_text refund_hint'>
								{refundMatch.refund
									? `Probably refunded ${refundMatch.refund.transaction_date.format('M/D')}`
									: `Probably a refund of ${refundMatch.refunds.transaction_date.format('M/D')}`}
							</span>
							}
							{isBankTransaction && showExternalTransactionControls &&
							<div className='bank_transaction_options'>
								<span className='hint_text not_yet'>
									Unsaved
								</span>
							</div>
							}
							{!!pending && <PendingText />}
							<span className='date'>
								{transaction_date
									? transaction_date.calendar(null, Transaction.transactionDateFormat)
									: 'Date Unknown'
								}
							</span>
						</div>
					</span>
					<span className={`amount col s3`}>
						<TransactionMoneyComponent
							{...this.props}
							categoryId={transaction.category_id}
							amount={amountDisplayed}
						/>
						<div>
						{isBankTransaction && showExternalTransactionControls &&
						<Button
							small
							danger={!transaction.hidden}
							success={transaction.hidden}
							onClick={transaction.hidden ? this.unhideBankTransaction : this.hideBankTransaction}
						>
							{transaction.hidden ?
								<span>Show</span> :
								<span>Hide</span>
							}
						</Button>
						}
						</div>
						{isPendingServerUpdate &&
						<React.Fragment>
							{!allowDeletingOfflineTransaction &&
							<div>
								<InlineCircleLoader
									size='extra-small'
								/>
							</div>
							}
							{allowDeletingOfflineTransaction &&
							<div>
								<Button
									onClick={() => {
										store.dispatch(removeOfflineTransactionAttempt(transaction));
									}}
								>
									Remove
								</Button>
							</div>
							}
						</React.Fragment>
						}
					</span>
				</React.Fragment>
			);
		}
	}

	render() {
		const {
			transaction,
			submittingTransactions,
			viewOnly,
			className,
			categoryGroups,
			categories,
			highlightedTransaction,
			addingForSpecificCategory,
			showCategory,
			transactionDelete,
			editOnly,
			transactionBeingEdited,
			highlightUndefined = true,
			isEditModal,
			transactionBeingEditedModalShouldBeOpen,
			lastEditedTransactionId,
			showExternalTransactionControls,
			style,
			showSplitCategories,
			categoryEditable,

		} = this.props;
		const { editing, dateEditDay } = this.state;
		const { where, category_id, pending, amount, transaction_date, description } = transaction;
		const isHighlighted = highlightedTransaction && highlightedTransaction === transaction.id;

		if(_.isString(transaction)) {
			return <Modal
				isOpen={true}
				closeOnBack={false}
			>
				<CircleLoader />
			</Modal>;

		}
		const amountDisplayed = amount ?
			moneyFormat(amount) :
			0;


		const isSaving = submittingTransactions && submittingTransactions[transaction.id] || (transaction.submit_id && !transaction.id);
		const isPendingServerUpdate = !!transaction.submit_id;

		const classes = new JqueryClassFaker(className);
		if(transaction.deleted) {
			classes.add('deleted');
			return null;
		}

		if(!isEditModal && transactionBeingEdited === transaction) {
			classes.add('is_being_edited');
		}

		if(viewOnly) {
			classes.add('view_only');
			if(!transaction.isComplete()) {
				classes.add('incomplete');
			}
		}
		if(isSaving) {
			classes.add('saving');
		}
		const category = getCategoryById(transaction.category_id);
		const isBankTransaction = transaction.isBankTransaction();
		if(isBankTransaction) {
			classes.add('category_bank_unsaved');
		} else {
			if(((!transaction.isSplit() && !category) || (transaction.isSplit() && transaction.splitsAreMissingACategory())) && !editing && showCategory) {
				classes.add('category_unknown');
			}
		}
		if(!transaction.id && !isEditModal && highlightUndefined) {
			classes.add(`transaction_id_${transaction.id}`); // .... Adds undefined
		}
		if(isHighlighted) {
			classes.add('highlighted');
		}
		const isClickable = !viewOnly && !editing;

		let categoryToDisplay = '';
		if(!transaction.isSplit()) {
			if(isEditModal) {
				categoryToDisplay = transaction.category_id;
			} else if(transaction.id) {
				categoryToDisplay = transaction.category_id || 0;
			} else {
				categoryToDisplay = transaction.category_id;
			}
		}

		if(editing) {
			// The url names the transaction being edited, and Back closes it through that.
			return (
				<Modal
					className='transaction_edit_modal'
					onClose={this.endTransactionEdit}
					isOpen={transactionBeingEditedModalShouldBeOpen}
					closeOnBack={false}
				>
					{(close) => (
						<TransactionEditPanel
							transaction={transaction}
							categories={categories}
							categoryToDisplay={categoryToDisplay}
							categoryLocked={!!addingForSpecificCategory}
							isSaving={!!isSaving}
							dateEditDay={dateEditDay}
							firstInputRef={this.firstInputRef}
							onChange={this.editTransactionChange}
							onBlur={this.editTransactionBlur}
							onEnter={this.onEnterPress}
							onAmountChange={this.editAmountChange}
							onToggleSign={this.toggleAmountSign}
							onCategories={this.categorySet}
							onSplitAmount={this.editSplitAmount}
							onSplitChange={this.editSplitChange}
							onSave={this.transactionSubmitter}
							onDelete={transactionDelete ? this.transactionDelete : null}
							onClose={close}
						/>
					)}
				</Modal>
			);
		}

		const EntireContainerTag = 'div';
		const entireTagProps = {};
		entireTagProps.className = 'transaction_summary_outer_container';
		entireTagProps.style = style;

		return (
			<EntireContainerTag
				{...entireTagProps}
			>
				<div
					className={`transaction_summary ${classes.toString()}`}
				>
					<div className='row'
					>
						{this.renderMainSummaryRow({
							categories,
							showCategory,
							isBankTransaction,
							editing,
							transaction,
							categoryToDisplay,
							addingForSpecificCategory,
							isSaving,
							where,
							description,
							pending,
							transaction_date,
							amountDisplayed,
							dateEditDay,
							lastEditedTransactionId,
							isPendingServerUpdate,
							onClick: isClickable && (isBankTransaction && showExternalTransactionControls ? this.addBankTransactionAsTransaction : this.highlightTransaction) || undefined
						})}
					</div>
					<TransactionSummarySplit
						transaction={transaction}
						editing={editing}
						showCategory={showCategory}
						showSplitCategories={showSplitCategories}
						categoryEditable={categoryEditable}
						editSplitAmount={this.editSplitAmount}
						editSplitChange={this.editSplitChange}
					/>
					{isPendingServerUpdate && transaction.submitError &&
					<div className='error'>
						Last Error: {transaction.submitError}
					</div>
					}
				</div>
				{isHighlighted && !viewOnly && !editing &&
				<ContainerTag className='row'>
					<Button
						onClick={viewOnly ? undefined : this.beginTransactionEdit}
						small
						flat>
						Edit Transaction
					</Button>
				</ContainerTag>
				}
			</EntireContainerTag>
		);
	}
}
